<app-navbar></app-navbar>
<section class="section-padding contact-top bg-light-theme">
    <div class="container">
        <div [innerHTML]="comment"></div>
    </div>
</section>
<app-footer2></app-footer2>